import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

// Jangan atur interceptor di dalam komponen
// Buat file untuk pengaturan global Axios jika diperlukan

function Utschool() {
    const navigate = useNavigate();
    const [utschool, setUtschool] = useState([]);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/utschool/readUtschool`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setUtschool(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat mengambil data.", "error");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const token = localStorage.getItem("token");
                    await axios.delete(
                        `${process.env.REACT_APP_API_URL}/utschool/deleteUtschool/${id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    fetchData();
                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Cover Foto",
            selector: (row) => (
                <img
                    src={
                        row.cover.startsWith("http")
                            ? row.cover
                            : `${process.env.REACT_APP_API_URL}/uploads/${row.cover}`
                    }
                    alt="Cover"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Penjelasan",
            selector: (row) => row.penjelasan,
            sortable: true,
            width: "150px",
        },
        {
            name: "Link Web",
            selector: (row) => (
                <a href={row.link_web} target="_blank" rel="noopener noreferrer">
                    {row.link_web}
                </a>
            ),
            sortable: true,
            width: "200px",
        },
        {
            name: "Link Instagram",
            selector: (row) => (
                <a href={row.link_ig} target="_blank" rel="noopener noreferrer">
                    {row.link_ig}
                </a>
            ),
            sortable: true,
            width: "200px",
        },
        {
            name: "Link YouTube",
            selector: (row) => (
                <a href={row.link_yt} target="_blank" rel="noopener noreferrer">
                    {row.link_yt}
                </a>
            ),
            sortable: true,
            width: "200px",
        },
        {
            name: "Foto 1",
            selector: (row) =>
                row.foto_1 ? (
                    <img
                        src={
                            row.foto_1.startsWith("http")
                                ? row.foto_1
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_1}`
                        }
                        alt="Foto 1"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Foto 2",
            selector: (row) =>
                row.foto_2 ? (
                    <img
                        src={
                            row.foto_2.startsWith("http")
                                ? row.foto_2
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_2}`
                        }
                        alt="Foto 2"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Foto 3",
            selector: (row) =>
                row.foto_3 ? (
                    <img
                        src={
                            row.foto_3.startsWith("http")
                                ? row.foto_3
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_3}`
                        }
                        alt="Foto 3"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Foto 4",
            selector: (row) =>
                row.foto_4 ? (
                    <img
                        src={
                            row.foto_4.startsWith("http")
                                ? row.foto_4
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_4}`
                        }
                        alt="Foto 4"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Foto 5",
            selector: (row) =>
                row.foto_5 ? (
                    <img
                        src={
                            row.foto_5.startsWith("http")
                                ? row.foto_5
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_5}`
                        }
                        alt="Foto 5"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Foto 6",
            selector: (row) =>
                row.foto_6 ? (
                    <img
                        src={
                            row.foto_6.startsWith("http")
                                ? row.foto_6
                                : `${process.env.REACT_APP_API_URL}/uploads/${row.foto_6}`
                        }
                        alt="Foto 6"
                        style={{ width: "100px", height: "70px" }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/utschoolEdit/${row.id}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
            width: "150px",
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">UT SCHOOL</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data UT SCHOOL</h3>
                                    </div>
                                    <div className="card-body">
                                        {utschool.length === 0 && (
                                            <Link
                                                to="/utschoolAdd"
                                                className="btn btn-primary mb-2"
                                            >
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Add Data
                                            </Link>
                                        )}
                                        <DataTable columns={columns} data={utschool} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Utschool;
